module.exports = __WEBPACK_EXTERNAL_MODULE_babylonjs_Misc_observable__;